import React from 'react';
import classNames from 'classnames';

import styles from './CustomTextAreaField.module.scss';

const CustomTextAreaField = ({ label, CustomIcon, className, ...inputProps }) => {
  const { value } = inputProps;

  return (
    <div className={styles.container}>
      <span className="blocking-span">
        <textarea className={classNames(styles.inputTextField, className)} {...inputProps} />
        <span className={value ? styles.floatingLabelFocused : styles.floatingLabel}>{label}</span>
        {CustomIcon && (
          <span className={styles.floatingLabelIcon}>
            <CustomIcon />
          </span>
        )}
      </span>
    </div>
  );
};

export default CustomTextAreaField;
